import { WithSubpages } from '../../subpages';
import { customerEnrollmentSubpages } from '../../subpages/dictionary';
import { PAGE_TITLE } from '../../consts';

import { MAIN_PAGE_PATH } from './paths';

const CUSTOMER_ENROLLMENT = () => (
  <WithSubpages
    mainPagePath={MAIN_PAGE_PATH}
    title={PAGE_TITLE.CUSTOMER_ENROLLMENT}
    items={customerEnrollmentSubpages}
  />
);

export default CUSTOMER_ENROLLMENT;
